export const getButtonStyle = (ctaType) => {
  let buttonStyle = { primary: true };
  if (ctaType === 'secondary' || !ctaType) {
    buttonStyle = { secondary: true };
  }
  if (ctaType === 'tertiary') {
    buttonStyle = { tertiary: true };
  }
  return buttonStyle;
};
